<template>
<div>
    <mu-appbar style="width: 100%;" color="#2196f3">
        <mu-button icon slot="left" @click="goback">
            <mu-icon value="arrow_back"></mu-icon>
        </mu-button>
        <div slot="right" style="display: flex;align-items: center;">
            <div></div>
            <mu-button icon >
                <mu-icon value="keyboard1_arrow_down"></mu-icon>
            </mu-button>
        </div>

        买入记录
    </mu-appbar>
    <mu-paper>
        <mu-card v-if="false">
            <div style="padding-top:10px;">今日输赢</div>
            <div style="display:flex;justify-content:center;margin:10px 5px;">
                <div style="width:33%">
                    <p>投注</p>
                    <p style="color:red">{{result[0]}}</p>
                </div>
                <div style="width:33%">
                    <p>中奖</p>
                    <p style="color:green">{{result[1] | number2str}}</p>
                </div>
                <div style="width:33%">
                    <p>盈利</p>
                    <p style="color:red">{{result[2] | number2str}}</p>
                </div>
            </div>
        </mu-card>
        <mu-row>
            <mu-col span="4">
                <mu-date-input type="date" v-model="startdate" container="bottomSheet" label-float @change="onchangedate"></mu-date-input>
            </mu-col>
            <mu-col span="1">
                <div style="padding:0.5rem 0.1rem;font-size: 1rem;">至</div>
            </mu-col>
            <mu-col span="4">
                <div style="display: flex;align-items: center;">

                    <mu-date-input type="date" v-model="enddate" container="bottomSheet" label-float @change="onchangedate"></mu-date-input>
                </div>

            </mu-col>
            <mu-col span="3">

                <mu-button color='orange' round @click="reset()">
                    <mu-icon value='refresh'></mu-icon>重置
                </mu-button>

            </mu-col>
        </mu-row>
        <mu-tabs :value.sync="tiaojian" color='pink' inverse indicator-color="pink" full-width @change="ontjchange">
            <mu-tab>全部</mu-tab>
            <mu-tab>已盈利</mu-tab>
            <mu-tab>待开盘</mu-tab>
        </mu-tabs>

        <div v-for="item,index in alldata" :key="item.hash" v-if="tiaojian==0">
            <mu-row style="font-size: 0.6rem;padding: 10px;">
                <mu-col>
                    <div style="text-align: left">
                        <div style="padding: 0.2rem">{{item.name | code2label}}</div>
                        <div style="padding: 0.2rem">{{item.type}}</div>
                    </div>
                </mu-col>

                <mu-col>
                    <div style="color: gray;padding: 0.2rem">{{item.expect}}期</div>
                    <div style="color: gray;padding: 0.2rem;display:flex;justify-content:space-around;" >
                        <div style="display:flex;color:white;justify-content:center;background:red;border-radius:10px;width:20px;height:20px;" >
                            {{item.openresult}}
                        </div>
                    </div>
                </mu-col>
                <mu-col>
                    <div style="text-align: right">
                        <div style="color: red;padding: 0.2rem">{{item.value}}元</div>
                        <div v-if="!item.isopen" style="color:black;padding: 0.2rem">
                            待开盘
                        </div>
                        <div v-if="item.result>0" style="color:red;padding: 0.2rem">
                            盈利🏆{{item.result.toFixed(2)}}元
                        </div>
                        <div v-if="item.result<0" style="color:green;padding: 0.2rem">
                            亏损 {{item.result.toFixed(2)}}元
                        </div>
                    </div>
                </mu-col>
            </mu-row>
            <div style="height: 0.5rem;background-color: #eeeeee"></div>
        </div>

        <div v-for="item,index in alldata" :key="index" v-if="tiaojian==1">
            <mu-row style="font-size: 0.6rem;padding: 10px;">
                <mu-col>
                    <div style="text-align: left">
                        <div style="padding: 0.2rem">{{item.name | code2label}}</div>
                        <div style="padding: 0.2rem">{{item.type}}</div>
                    </div>
                </mu-col>

                <mu-col>
                    <div style="color: gray;padding: 0.2rem">{{item.expect}}期</div>
                    <div style="color: gray;padding: 0.2rem;display:flex;justify-content:space-around;" >
                        <div style="display:flex;color:white;justify-content:center;background:red;border-radius:10px;width:20px;height:20px;" >
                            {{item.openresult}}
                        </div>
                    </div>
                </mu-col>
                <mu-col>
                    <div style="text-align: right">
                        <div style="color: red;padding: 0.2rem">{{item.value}}元</div>

                        <div style="color:red;padding: 0.2rem">
                            盈利🏆{{item.result.toFixed(2)}}元
                        </div>
                    </div>
                </mu-col>
            </mu-row>
            <div style="height: 0.5rem;background-color: #eeeeee"></div>
        </div>
        <div v-for="item,index in alldata" :key="index" v-if="tiaojian==2">
            <mu-row style="font-size: 0.6rem;padding: 10px;">
                <mu-col>
                    <div style="text-align: left">
                        <div style="padding: 0.2rem">{{item.name | code2label}}</div>
                        <div style="padding: 0.2rem">{{item.type}}</div>
                    </div>
                </mu-col>

                <mu-col>
                    <div style="color: gray;padding: 0.2rem">{{item.expect}}期</div>
                </mu-col>
                <mu-col>
                    <div style="text-align: right">
                        <div style="color: red;padding: 0.2rem">{{item.value}}元</div>
                        <div style="color:black;padding: 0.2rem">
                            待开盘
                        </div>

                    </div>
                </mu-col>
            </mu-row>
            <div style="height: 0.5rem;background-color: #eeeeee"></div>
        </div>
        <mu-flex justify-content="center" v-if="total>11">
            <mu-pagination raised circle :total="total" :current.sync="cpage" @change="refresh()"></mu-pagination>
        </mu-flex>

        <mu-popover style="top: 56px;width:100%;max-width: 100%;" :open.sync="open">
            <div style="display: flex;flex-wrap: wrap;overflow-y: scroll;height: 300px;text-align: center;justify-content: center;">
                <div style="width:30%;font-size: 0.6rem;border: gray 1px solid;margin: 0.2rem;display: flex;align-items: center;justify-content: center;" v-for="code in sclist" @click="tpclick(code,ds(code))">
                    {{ds(code)}}
                </div>
            </div>
        </mu-popover>

    </mu-paper>

</div>
</template>

<script>
import Api from '@/api'
import moment from 'moment'
export default {

    created() {
        this.refresh();
    },
    actived() {
        this.refresh();
    },
    
    data() {
        return {
            tplabel: " 全部彩种",
            tp: "all",
            cpage: 1,
            startdate: moment().utcOffset(8).startOf('day').format('YYYY-MM-DD'),
            enddate: moment().utcOffset(8).endOf('day').format('YYYY-MM-DD'),
            columns: [{
                    title: "彩种",
                    name: 'name',
                    width: "20%"
                },
                {
                    title: "期号",
                    name: 'expect',
                    width: "30%"
                },

                {
                    title: "金额",
                    name: 'value',
                    width: "10%"
                },
                {
                    title: "类型",
                    name: "type",
                    width: "10%"
                },
                {
                    title: "开奖",
                    name: 'open_number',
                    width: "20%"
                },
                {
                    title: "结果",
                    name: "result",
                    width: "20%"
                }

            ],
            done: 3,
            total: 1,

            datalist: [

            ],
            datalist1: [],
            datalist2: [],
            open: false,
            tiaojian: 0,
            sclist: ["hsbs", "barclays"],

           
        }
    },
    computed: {
        result() {

            let s = this.datalist.length;
            let bet_total = 0;
            let rs_total = 0;
            let win_total = 0;
            for (let i = 0; i < s; i++) {
                bet_total += this.datalist[i].value;
                rs_total += this.datalist[i].result;
            }
            win_total = rs_total - bet_total;

            return [bet_total, rs_total, win_total];
        },

        alldata() {
            return this.datalist;
        },
       
  
},
filters: {
        number2str(n) {
            return n.toFixed(1)
        },
        code2label(code){
       
         if(!code){
             return ""
         }
         return code;
         
       }
    },

    methods: {
        ds(code) {
            return code
            
        },
        ontjchange(value) {
            this.cpage = 1;
            this.refresh();
        },
        tpclick(value, label) {
            this.tp = value
            this.tplabel = label;
            this.open = false;
            this.refresh();

        },
        onchangedate(value) {

            //this.startdate=moment().utcOffset(8).startOf('day').format('YYYY-MM-DD')
            //this.enddate=moment().utcOffset(8).endOf('day').format('YYYY-MM-DD')

            this.refresh()

        },
        refresh() {
            this.datalist = [];
            this.done = 2 - this.tiaojian;

            Api.getBetRecords(this.tp, moment(this.startdate).format("YYYY-MM-DD"), moment(this.enddate).format("YYYY-MM-DD"), this.done, this.cpage).then((res) => {
                this.total = res.data.count; //Math.ceil(res.data.count/10);

                this.datalist = res.data.data;
                this.datalist = this.datalist.map((item) => {
                    item.hash = Math.random();
                    return item;
                })

            })

        },
        reset() {
            this.startdate = moment().utcOffset(8).startOf('day').format('YYYY-MM-DD')
            this.enddate = moment().utcOffset(8).endOf('day').format('YYYY-MM-DD')
            this.tp = "all"
            this.tplabel = "全部彩种"
            this.done = 2;
            this.tiaojian = 0;
            this.refresh()
        },
        goback() {
            this.$router.go(-1);
        },
        showCaiPiao() {
            this.open = true;

        },
        computeResult(open_number) {
            let total = 0;
            let rs = [];

            let he = 10;
            if (open_number.length == 5) {
                he = 22
            }

            if (open_number.length > 0) {

                total = eval(open_number.join("+"));

                rs.push(total);

                if (total % 2 == 0) {
                    rs.push("双")
                } else {
                    rs.push('单')
                }
                if (total > he) {
                    rs.push("大")
                } else if (total < he + 1) {
                    rs.push("小")
                }

            }
            return rs;
        }
    }
}
</script>

<style>
.mu-table table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    table-layout: fixed;
}

.ball {
    background-color: #2d4d7e;
    color: white;
    text-align: center;
    font-size: 1rem;
    height: 2rem;
    line-height: 2rem;
    width: 2rem;
    border-radius: 2rem;
    margin: 0.2rem;
    border: solid;
    border-width: 1px;
    border-color: white;
    color: white;
}
</style>



// WEBPACK FOOTER //
// src/pages/BetRecords.vue